module.exports = __webpack_public_path__ + "img/Icon-Alert.4ab869c9.svg";